import { createContext, use } from 'react';
import type { BowtieConfiguration } from '../@types/common-data-types';

export const ConfigurationContext = createContext<BowtieConfiguration | undefined>(undefined);

// context consumer hook
export const useConfigurationContext = () => {
  const context = use(ConfigurationContext);

  if (context === undefined) {
    throw new Error('useConfigurationContext must be used within ConfigurationProvider');
  }

  return context;
};
